import gql from 'graphql-tag';
export default gql`
  mutation($activationCode: String!, $token: String!) {
    activate(activationCode: $activationCode, token: $token) {
      code
      token
    }
  }
`;
